//---------	Global imports
import React from 'react';

//---------  Plugins
import { onTemplateLoad } from '../Components/Shared/Commons'

//---------	Translations
import { T } from '../../translations';

//---------	Components
import Banner from "../components/Banner";
import About from "../components/About";
import Newsletter from "../components/Newsletter";
import SEO from '../components/SEO';


class AboutTemplate extends React.Component {

  //---------	Constructor
  constructor(){
    super();
    
    this.state = {
      loading: true
    };
  }

  //---------	React functions
  componentDidMount() {
    setTimeout(() => this.setState({loading: false}), 300)
    setTimeout(() => onTemplateLoad());
  }
  
  render() {
    const data = this.props.data.markdownRemark.frontmatter;
    const seo = {
      title: `${T.SEO.title.about} - ${data.title} | Calipsy`
    };
    
    return (
      <div className={this.state.loading ? 'CalipsyWrapper CalipsyWrapper-loading' : 'CalipsyWrapper'}>
  
        <SEO {...seo}/>
  
        <div className="CalipsySpinner"></div>
        <div className="CalipsyWrapper-container">
          <Banner data={data.banner}/>
    
          <About />
          
          <Newsletter />
        </div>
  
      </div>
    );
  }
}
export default AboutTemplate;

export const pageQuery = graphql`
  query AboutQuery($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      id
      frontmatter {
        title
        banner {
          imageUrl
          type
          anchor
        }
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/templates/about.js